import { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button, EmptyState, LoadingState } from '../components/ui';
import { loadMyQueries } from '../lib/account';
import type { AskQueryRow } from '../lib/account';

export function StudentMyDoubts() {
  const [rows, setRows] = useState<AskQueryRow[]>();
  useEffect(() => {
    let active = true;
    void loadMyQueries().then((next) => { if (active) setRows(next); }).catch(() => { if (active) setRows([]); });
    return () => { active = false; };
  }, []);

  return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon"><MessageCircle size={28} /></div><div><h1>My doubts</h1><p>Every question you have sent to the AyurGuide team</p></div></section>
    {!rows ? <LoadingState /> : rows.length
      ? <section className="utility-list">{rows.map((row) => <div className="utility-row" key={row.objectId}>
        <span><MessageCircle size={17} /></span>
        <div><strong>{row.Subject || 'Question'}</strong><small>{row.Query}</small></div>
        <span className="utility-status">{row.createdAt ? new Date(row.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' }) : ''}</span>
      </div>)}</section>
      : <EmptyState icon={MessageCircle} title="No questions yet" description='Anything you send from "Ask a doubt" shows up here.' action={<Link to="/ask-query"><Button variant="soft">Ask your first question</Button></Link>} />}
  </div>;
}
